module.exports = (s) => {
  return [
    {
      name: '名称',
      value: 'name',
    },
    {
      name: '路由',
      value: 'api_url',
    },
    {
      name: '权限',
      value: 'menu_permission',
    },
    {
      name: '排序',
      value: 'sort',
    },
    {
      name: '操作',
      width: 100,
      format: (row) => {
        const h = s.$createElement;
        const ele = h('el-button', {
          props: {
            type: 'primary',
            size: 'mini',
            plain: true,
          },
          on: {
            click: () => {
              s?.edit(row);
            },
          },
        }, '编辑');
        return ele;
      },
    },
  ];
};
